@if (!dismissed()) {
  <div
    class="relative z-20 flex min-h-[35px] items-center justify-center border-b border-solid px-6 py-3 font-medium"
    [class]="containerClass()"
  >
    <div class="flex items-center justify-center gap-2">
      @if (bannerConfig(); as config) {
        <dojo-icon [icon]="config.icon" [size]="16" />
      }
      @if (isHtml()) {
        <span class="text-center" [innerHTML]="bannerMessage()"></span>
      } @else {
        <span class="text-center">{{ bannerMessage() }}</span>
      }
    </div>

    @if (isDismissible()) {
      <dojo-icon-button
        class="absolute right-2"
        [icon]="'xmark'"
        [size]="'xs'"
        [transparent]="true"
        (click)="dismiss()"
      />
    }
  </div>
}
